export default function Logo({ light = false }) {
  return (
    <span className="inline-flex items-center gap-3 select-none">
      <svg width="34" height="34" viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill={light ? "#FFFFFF" : "#0B1D40"} />
        <text
          x="32" y="38"
          fontFamily="'Cormorant Garamond', Georgia, serif"
          fontSize="24" fontStyle="italic"
          fill={light ? "#0B1D40" : "#FFFFFF"}
          textAnchor="middle" letterSpacing="1"
        >
          LA
        </text>
        <path d="M14 46 H50" stroke="#D41224" strokeWidth="4" strokeLinecap="round" />
      </svg>
      <span className={`font-display text-xl md:text-2xl tracking-[0.04em] ${light ? "text-white" : "text-ink"}`}>
        LATUAUTONLINE
      </span>
    </span>
  );
}
